/**
 * Settings › Plan & billing — a placeholder until billing has an endpoint.
 *
 * No control: a button with nothing behind it breaks R19. Starts at `<h2>`
 * because `ChromeLayout` owns the document's only `<h1>`.
 */
export function Billing() {
  return (
    <section aria-labelledby="billing-title">
      <h2 id="billing-title">Plan &amp; billing</h2>
      <p>Plans and billing are coming soon. Nothing here needs your attention.</p>
    </section>
  )
}
